<template>
    <ion-header class="ion-no-border ">
        <ion-toolbar class="" color="primary">
            <ion-title class="text-lg">Prévisualisation du livre</ion-title>
            <ion-button v-if="hasOutline" slot="end" fill="clear" size="large" color="white"
                        @click="$refs.preview?.openOutline($event)">
                <img src="assets/icon/book_summary.png" alt="Sommaire" class="icone-sommaire">
            </ion-button>
            <ion-button slot="end" fill="clear" @click="dismiss" size="large" color="white">
                <ion-icon slot="icon-only" :icon="closeIcon"></ion-icon>
            </ion-button>
        </ion-toolbar>
    </ion-header>
    <ion-content>
        <book-preview-component v-if="bookId" ref="preview" :book-id="bookId" :initial-page="page"
                                @ready="hasOutline = $event.outline.length > 0"></book-preview-component>
    </ion-content>

</template>

<script>
import {
    IonButton,
    IonContent,
    IonHeader, IonIcon, IonToolbar, IonTitle,
    modalController
} from '@ionic/vue';
import { defineComponent } from 'vue';

import {
    close as closeIcon,
} from 'ionicons/icons';
import BookPreviewComponent from "@/components/book/BookPreviewComponent.vue";

export default defineComponent({
    name: 'ModalBookPreview',
    components: {
        BookPreviewComponent,
        IonButton,
        IonToolbar,
        IonContent,
        IonHeader,
        IonTitle,
        IonIcon,
    },
    props: {
        bookId: [String, Number],
        // Numéro de page, ou type de page ('welcome', 'thanks') quand on ouvre l'aperçu
        // depuis l'édition du message correspondant.
        page: [String, Number],
    },
    data() {
        return {
            closeIcon,
            hasOutline: false,
        };
    },
    methods: {

        dismiss: function () {
            return modalController.dismiss(null, 'cancel');
        },

    },
})
;
</script>

<style lang="scss" scoped>
ion-content, ion-header, ion-toolbar {
    --background: var(--ion-color-primary);
    background-color: var(--ion-color-primary);
}

ion-footer {
    --background: var(--ion-color-tertiary);
    background-color: var(--ion-color-tertiary);
}

/* L'icône est un aplat noir : on la repeint en blanc pour la barre, comme la croix. */
.icone-sommaire {
    height: 26px;
    filter: brightness(0) invert(1);
}
</style>
